import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIcon, ProhibitIcon } from '@fronton/icons-react';
import { RegularButton, BaseButton } from 'fronton-react';
import { TTintColor, TTintColorWithQuantity } from '../../types';
import { ColorIcon } from '../color-icon';
import {
  addColorButton,
  colorPaletteContainer,
  prohibitedIconContainer,
  transparentColorButton,
  transparentColorButtonActive,
} from './styles';
import { ButtonWrapperForIntegration } from '../button-wrapper-for-integration';

type TProps = {
  selectedTintColors: TTintColorWithQuantity[] | never;
  activeColor: TTintColor | null;
  openChooseColorModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  handleChangeActiveColor: (color: TTintColorWithQuantity) => void;
  handleClickTransparentColorButton: () => void;
  isShowAddNewColorButton: boolean;
  isTintServiceAvailable: boolean;
  dataForIntegration: string;
};

export const ColorPalette = ({
  selectedTintColors,
  activeColor,
  openChooseColorModal,
  handleClickTransparentColorButton,
  handleChangeActiveColor,
  isShowAddNewColorButton,
  isTintServiceAvailable,
  dataForIntegration,
}: TProps) => {
  const { t } = useTranslation();

  return (
    <div data-qa="color-palette-pdp" className={colorPaletteContainer}>
      <BaseButton
        data-qa="transparent-color-button-pdp"
        aria-label={t('product-info.pdp-select-tint-color.aria_labels.choose_transparent_color')}
        onClick={handleClickTransparentColorButton}
        className={`${transparentColorButton} ${activeColor === null ? transparentColorButtonActive : ''}`}
      >
        <div className={prohibitedIconContainer}>
          <ProhibitIcon type="outline" size="l" color="text-primary" />
        </div>
      </BaseButton>

      {selectedTintColors.map((color) => {
        return (
          <BaseButton
            data-qa={`select-${color.COLOR_NAME}-color-button-pdp"`}
            aria-label={`${t('product-info.pdp-select-tint-color.aria_labels.choose_color')} ${
              color?.COLOR_NAME
            }`}
            key={color.COLOR_NAME}
            onClick={() => handleChangeActiveColor(color)}
          >
            <ColorIcon
              isActive={!!(activeColor && color.COLOR_NAME === activeColor.COLOR_NAME)}
              color={color.HEX}
            />
          </BaseButton>
        );
      })}

      {isShowAddNewColorButton && (
        <ButtonWrapperForIntegration
          dataQa="select-tint-color-plus-button-pdp"
          isTintAvailable={isTintServiceAvailable}
          openChooseColorModal={openChooseColorModal}
          dataForIntegration={dataForIntegration}
        >
          <RegularButton
            className={addColorButton}
            rounded
            variant="pseudo"
            iconOnly
            aria-label={t('product-info.pdp-select-tint-color.aria_labels.add_additional_color')}
          >
            <PlusIcon type="outline" size="l" color="background-primary" />
          </RegularButton>
        </ButtonWrapperForIntegration>
      )}
    </div>
  );
};
